module.exports = "<dashboard-compute></dashboard-compute>\n<main class=\"content-area\">\n    <router-outlet></router-outlet>\n</main>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/compute/compute-vcd/compute-vcd.html
// module id = VR6s
// module chunks = 0